import * as React from 'react'
import { Controller, ControllerProps, FieldValues } from 'react-hook-form'
import { MaskedInput, MaskedInputProps } from './MaskedInput'
import { useIntl } from 'react-intl'

type TelFieldProps = Omit<MaskedInputProps, 'format'>
const _TelField = ({ value, ...props }: TelFieldProps, ref: React.Ref<HTMLInputElement>) => {
  const cleanedValue = typeof value === 'string' ? value.replace(/^1+/, '').slice(0, 10) : value
  return (
    <MaskedInput
      inputRef={ref}
      format="(###) ###-#####" // extra digit allowed for leading 1 that will be removed during onChange
      // mask="_"
      valueIsNumericString
      placeholder="(555) 555-5555"
      {...props}
      value={cleanedValue}
      type="tel"
    />
  )
}
export const TelField = React.forwardRef(_TelField)

/**
 * A controlled input for telephone numbers. Note that custom validation rules are not supported.
 * If the phone number is required, just supply the `required` prop.
 */
type TelFieldControllerProps<T extends FieldValues> = Omit<TelFieldProps, 'name' | 'variant'> &
  Pick<ControllerProps<T>, 'name' | 'control'>
export const TelFieldController = <T extends FieldValues>({
  name,
  control,
  ...props
}: TelFieldControllerProps<T>) => {
  const intl = useIntl()
  return (
    <Controller
      render={({ field, formState: { submitCount }, fieldState: { error, isTouched } }) => {
        const isError = Boolean((isTouched || submitCount > 0) && error?.message)
        return (
          <TelField
            {...props}
            {...field}
            error={isError}
            helperText={(isError && error?.message) || props.helperText}
          />
        )
      }}
      name={name}
      control={control}
      rules={{
        required: props.required
          ? intl.formatMessage({ id: 'profile.cellphone.validation.required_length' })
          : undefined,
        pattern: {
          value: /^(?:\d{10})?$/, // 10 digits or empty
          message: intl.formatMessage({ id: 'profile.cellphone.validation.required_length' }),
        },
      }}
    />
  )
}
